import { inject, ref } from "vue";
import braintree from "braintree-web";
import {
    deletePaypalNonce,
    getPaypalNonce,
    setupPaypalCheckout,
} from "../api/checkout";

export function usePaypal() {
    const emitter = inject<any>("mitt");
    const paypalError = ref(false);

    function generatePaypalToken() {
        getPaypalNonce()
            .then((data) => {
                emitter.emit("paypalTokenGenerated", data);
            })
            .catch((error) => {
                if (
                    typeof error.response !== "undefined" &&
                    Object.prototype.hasOwnProperty.call(
                        error.response,
                        "data",
                    ) &&
                    Object.prototype.hasOwnProperty.call(
                        error.response.data,
                        "errors",
                    )
                ) {
                    emitter.emit("paypalTokenError", {
                        data: error.response.data,
                    });
                }
            });
    }

    function forgetPaypalNonce() {
        deletePaypalNonce().then(() => (window.location.href = "/checkout"));
    }

    function initiatePaypalCheckout(token: string, amount: string) {
        if (token) {
            braintree.client.create(
                {
                    authorization: token,
                },
                (clientError: any, clientInstance: any) => {
                    braintree.paypalCheckout.create(
                        {
                            client: clientInstance,
                        },
                        (
                            paypalCheckoutError: any,
                            paypalCheckoutInstance: any,
                        ) => {
                            paypalCheckoutInstance.loadPayPalSDK(
                                {
                                    intent: "authorize",
                                    currency: "USD",
                                    commit: false,
                                },
                                () => {
                                    paypal
                                        .Buttons({
                                            fundingSource:
                                                paypal.FUNDING.PAYPAL,

                                            style: {
                                                color: "white",
                                                label: "pay",
                                            },

                                            createOrder: () => {
                                                emitter.emit(
                                                    "paypalPopupOpen",
                                                    true,
                                                );

                                                return paypalCheckoutInstance.createPayment(
                                                    {
                                                        flow: "checkout",
                                                        amount: amount,
                                                        currency: "USD",
                                                        intent: "authorize",
                                                        enableShippingAddress: true,
                                                        shippingAddressEditable: true,
                                                    },
                                                );
                                            },

                                            onApprove: (data: any) => {
                                                return paypalCheckoutInstance.tokenizePayment(
                                                    data,
                                                    (
                                                        error: any,
                                                        payload: any,
                                                    ) => {
                                                        if (error) {
                                                            if (
                                                                error.code ===
                                                                "PAYPAL_POPUP_OPEN_FAILED"
                                                            ) {
                                                                return emitter.emit(
                                                                    "paypalCheckoutError",
                                                                );
                                                            }

                                                            if (
                                                                error.code !==
                                                                "PAYPAL_POPUP_CLOSED"
                                                            ) {
                                                                Bugsnag.notify(
                                                                    error.code,
                                                                );
                                                                return;
                                                            }

                                                            return emitter.emit(
                                                                "paypalPopupOpen",
                                                                false,
                                                            );
                                                        }

                                                        emitter.emit(
                                                            "paypalPopupOpen",
                                                            false,
                                                        );
                                                        setupPaypalCheckout(
                                                            payload,
                                                        )
                                                            .then(
                                                                () =>
                                                                    (window.location =
                                                                        "/checkout" as string &
                                                                            Location),
                                                            )
                                                            .catch(() =>
                                                                emitter.emit(
                                                                    "paypalCheckoutError",
                                                                ),
                                                            );
                                                    },
                                                );
                                            },

                                            onCancel: () =>
                                                emitter.emit(
                                                    "paypalPopupOpen",
                                                    false,
                                                ),

                                            onError: (error: any) => {
                                                Bugsnag.notify(
                                                    JSON.stringify(error),
                                                );
                                                emitter.emit(
                                                    "paypalCheckoutError",
                                                );
                                            },
                                        })
                                        .render("#paypal-button")
                                        .then(() =>
                                            emitter.emit(
                                                "alternateCheckoutAvailable",
                                                true,
                                            ),
                                        );
                                },
                            );
                        },
                    );
                },
            );
        }
    }

    return {
        paypalError,
        generatePaypalToken,
        forgetPaypalNonce,
        initiatePaypalCheckout,
    };
}
